export enum TARGET_AUDIENCE {
  AGE_18_TO_49 = '18-49',
  AGE_25_TO_54 = '25-54',
  AGE_40_TO_64 = '40-64',
  AGE_55_PLUS = '55+',
  AGE_40_PLUS = '40+',
  AGE_18_PLUS = '18+',
  FEMALES_18_TO_49 = 'Females 18-49',
  FEMALES_25_TO_54 = 'Females 25-54',
  FEMALES_40_TO_64 = 'Females 40-64',
  MALES_18_TO_49 = 'Males 18-49',
  MALES_25_TO_54 = 'Males 25-54',
  MALES_40_TO_64 = 'Males 40-64',
  HOUSEHOLD_INCOME_60K_PLUS_25_TO_54 = 'Household Income $60k+ 25-54',
  HOMEOWNER_25_TO_54 = 'Homeowner 25-54',
  MAIN_SHOPPER_25_TO_54 = 'Main Shopper 25-54',
  MAIN_SHOPPER_WITH_KIDS_0_TO_14_IN_HOME = 'Main Shopper with kids 0-14 in Home',
  AGE_25_TO_64 = '25-64'
}

export enum DAY_LOWERCASE {
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
  SUNDAY = 'sunday'
}

export enum DAY_PASCAL {
  SUNDAY = 'Sunday',
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday'
}

export enum DAY_TRUNCATED {
  SUN = 'Sun',
  MON = 'Mon',
  TUE = 'Tue',
  WED = 'Wed',
  THU = 'Thu',
  FRI = 'Fri',
  SAT = 'Sat'
}

export enum DURATION_SECONDS {
  FIVE = 'five',
  TEN = 'ten',
  FIFTEEN = 'fifteen',
  THIRTY = 'thirty',
  FORTY_FIVE = 'fortyfive',
  SIXTY = 'sixty',
  NINETY = 'ninety'
}

// move this to environment variables once lambdas are refined for actual production.
// PreProd: https://wip-api.pptvnz.io/audiencetradingtool/calculator
export const GOOGLE_SHEET_LAMBDA_URL = 'https://api.tvnz.io/audiencetradingtool/calculator';

export enum GOOGLE_SHEET_API_OUTCOME {
  SUCCESS = 'success',
  ERROR = 'error'
}

export enum MONTH_PASCAL {
  JANUARY = 'January',
  FEBRUARY = 'February',
  MARCH = 'March',
  APRIL = 'April',
  MAY = 'May',
  JUNE = 'June',
  JULY = 'July',
  AUGUST = 'August',
  SEPTEMBER = 'September',
  OCTOBER = 'October',
  NOVEMBER = 'November',
  DECEMBER = 'December'
}

export enum MONTH_LOWERCASE {
  JANUARY = 'january',
  FEBRUARY = 'february',
  MARCH = 'march',
  APRIL = 'april',
  MAY = 'may',
  JUNE = 'june',
  JULY = 'july',
  AUGUST = 'august',
  SEPTEMBER = 'september',
  OCTOBER = 'october',
  NOVEMBER = 'november',
  DECEMBER = 'december'
}

export enum MONTH_TRUNCATED {
  JAN = 'Jan',
  FEB = 'Feb',
  MAR = 'Mar',
  APR = 'Apr',
  MAY = 'May',
  JUN = 'Jun',
  JUL = 'Jul',
  AUG = 'Aug',
  SEP = 'Sep',
  OCT = 'Oct',
  NOV = 'Nov',
  DEC = 'Dec'
}

export enum TVNZ_LOGO_IMAGE_PATH {
  ONE = '/images/tvnz_one_logo.png',
  TWO = '/images/tvnz_two_logo.png',
  DUKE = '/images/tvnz_duke_logo.png',
  PLUS = '/images/tvnz_plus_logo.png'
}

export enum VARIABLE_OPTION {
  EDIT_ENTIRE_CAMPAIGN,
  EDIT_MONTHS_INDIVIDUALLY
}

export enum DEFINE_OPTION {
  TARPS,
  BUDGET,
  ZEROS
}

export enum TARGETS {
  BUDGET = 'budget',
  TARPS = 'tarps',
  IMPACT = 'zeros'
}

export enum RIGHT_SECTION_LABEL {
  BUDGET = 'Budget',
  TARPS = 'TARPs',
  IMPACT = 'Impacts (000s)'
}

export enum RATIOS {
  FIVE = 0.25,
  TEN = 0.5,
  FIFTEEN = 0.6,
  THIRTY = 1,
  FORTY_FIVE = 1.45,
  SIXTY = 1.8,
  NINETY = 3
}

export enum DIRECTION {
  DOWN,
  UP
}

export const DATE_FORMAT = 'dd-MM-yyyy';

export const TVNZ_OPTIMISE = 0;

export const MINIMUM_STATION_GRID_LOADING = 0;

export const TWO_DECIMAL_PLACES = 2;

export const AGE_RANGE_REGEX = /(\d{1,2}(?:-\d{1,2}|\+))/;

export const GENDER_REGEX = /Female|Male/i;

export const HOMEOWNER_REGEX = /Homeowner/i;

export const MAIN_SHOPPER_REGEX = /Main Shopper/i;

export const INCOME_REGEX = /\$\d+k\+/;

export const UNSPECIFIED = 'Unspecified';

export const ZERO_PEAK: number = 0;
